import { Set } from 'immutable';
import {
  ArrayNodeOutput,
  MatchFunction,
  NodeOutput,
  ParseFunction,
  ReactArrayRule,
  ReactNodeOutput,
} from 'simple-markdown';

export type QuizBlankLabels = string[];

export const enum MarkupRule {
  Bold = 'simpleBold',
  Break = 'br',
  InlineCode = 'inlineCode',
  Italic = 'simpleItalic',
  Link = 'link',
  QuizBlank = 'quizBlank',
  Ruby = 'ruby',
  Sentence = 'sentence',
  Strikethrough = 'del',
  Text = 'text',
  Url = 'url',
  Word = 'word',
}

export interface ICustomState {
  quizBlankIndex: number;
  ruleSet: Set<MarkupRule>;
}

export type CustomArrayRule = ReactArrayRule & { text: ArrayNodeOutput<string> };

export type TextOutput = NodeOutput<string>;

export interface ICustomRuleBase {
  parse: ParseFunction;
  match: MatchFunction;
  react: ReactNodeOutput | null;
  text: TextOutput | null;
}

export interface ICustomRule extends ICustomRuleBase {
  order: number;
}

/**
 * @param configurable - If true, the rule will be checked to see if it's in the ruleset.
 */
export interface ICustomRuleOptions {
  configurable: boolean;
}

export type CustomRules = {
  [I in MarkupRule]: ICustomRule;
};
